<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>行車軌跡</h3>
          <hr />
        </div>
      </div>
      <div class="x_panel">
        <div class="row">
          <div class="col-md-12">
            <h4 class="col-md-1">起始時間：</h4>
            <DateSelect ref="startTime"></DateSelect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4 class="col-md-1">結束時間：</h4>
            <DateSelect ref="endTime" :isEndTime="true"></DateSelect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-1">
              <h4>搜尋司機：</h4>
            </div>
            <select
              id="heard"
              class="inputstylesmall col-md-4 form-control blockmargin fontSize16"
              style="max-width: 300px"
              v-model="driver_index"
              @change="getDriverInfo(driver_index)"
            >
              <option value="-1" disabled>呼號 / 姓名</option>
              <option v-for="driver in driver_options" :value="driver">
                {{ driver.callNumber }} - {{ driver.name }}
                {{ driver.hasSealed ? ' - (已被封存)' : '' }}
              </option>
            </select>
            <div class="col-md-4 blockmargin">
              <button
                @click="searchTransactionList"
                type="button"
                class="btn btn-default btn-primary blockmargin_left fontSize16"
              >
                搜尋
              </button>
            </div>
          </div>
        </div>
        <template>
          <el-tabs type="border-card">
            <el-tab-pane label="司機資料">
              <template v-if="driverInfo.name !== ''">
                <el-row :gutter="6">
                  <el-col :span="8">
                    <h4>
                      呼號：
                      <span>{{ driverInfo.callNumber }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      車號：
                      <span>{{ driverInfo.licence }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      車齡：
                      <span>{{ driverInfo.carYear }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      司機姓名：
                      <span>{{ driverInfo.name }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      性別：
                      <span v-if="driverInfo.gender !== ''">
                        {{ driverInfo.gender ? '女' : '男' }}
                      </span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      廠牌：
                      <span>{{ driverInfo.carBrand }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      電話：
                      <span>{{ driverInfo.phoneNumber }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      聯絡電話1：
                      <span>{{ driverInfo.contactPhoneNumber1 }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      聯絡電話2：
                      <span>{{ driverInfo.contactPhoneNumber2 }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      手機型號：
                      <span>{{ driverInfo.mobileModelNumber }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      系統版本：
                      <span>{{ driverInfo.mobileOsVersion }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="8">
                    <h4>
                      APP 版本：
                      <span>{{ driverInfo.appVersion }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="24">
                    <h4>
                      備註：
                      <span>{{ driverInfo.note }}</span>
                    </h4>
                  </el-col>
                  <el-col :span="24">
                    <h4>
                      最後登入時間：
                      <span v-if="driverInfo.lastLoginDate !== ''">
                        {{ changeTime(driverInfo.lastLoginDate) }}
                      </span>
                    </h4>
                  </el-col>
                </el-row>
              </template>
              <div v-else>
                <h3 class="text-center" style="padding: 60px 0">
                  請選擇司機資料
                </h3>
              </div>
            </el-tab-pane>
            <el-tab-pane label="地圖軌跡及軌跡列表">
              <div class="col-lg-6 col-md-8" v-show="driving_track.length != 0">
                <div style="display: flex">
                  <el-input
                    v-model="searchData.value"
                    style="width: 90%"
                    placeholder="請輸入地址"
                  />
                  <button
                    type="button"
                    style="padding: 9px 25px; margin: 0px 0px 30px 15px"
                    class="btn btn-primary"
                    @click="setLocationMarker"
                  >
                    地址搜尋
                  </button>
                </div>
                <div class="x_panel">
                  <div class="x_content">
                    <div class="row blockmargin">
                      <div class="col-md-3">
                        <a class="black-word fontSize20">
                          <img
                            src="../../../src/assets/images/driver-status/taxi.png"
                          />
                          空車
                        </a>
                      </div>
                      <div class="col-md-3">
                        <a class="black-word fontSize20">
                          <img
                            src="../../../src/assets/images/driver-status/take_passenger.png"
                          />
                          載客中
                        </a>
                      </div>
                      <div class="col-md-3">
                        <a class="black-word fontSize20">
                          <img
                            src="../../../src/assets/images/driver-status/hailing.png"
                          />
                          派遣中
                        </a>
                      </div>
                      <div class="col-md-3">
                        <a class="fontSize20 black-word">
                          <img
                            src="../../../src/assets/images/driver-status/shift.png"
                          />
                          排班車
                        </a>
                      </div>
                    </div>
                    <div class="row blockmargin">
                      <div class="col-md-3">
                        <a class="fontSize20 black-word">
                          <i class="fa fa-ban fa-1x"></i>
                          停權
                        </a>
                      </div>
                      <div class="col-md-3">
                        <a class="fontSize20 black-word">
                          <img
                            src="../../../src/assets/images/driver-status/rest.png"
                          />
                          休息
                        </a>
                      </div>
                      <div class="col-md-3">
                        <a class="fontSize20 black-word">
                          <img
                            src="../../../src/assets/images/driver-status/logout.png"
                          />
                          登出
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-show="driving_track.length != 0">
                <button class="btn btn-primary" @click="getAlltrack()">
                  顯示所有軌跡
                </button>
              </div>
              <div class="col-md-12">
                <hr />
                <div class="row">
                  <div
                    class="col-md-6"
                    style="height: 990px; margin-top: 20px"
                    id="map"
                    v-show="driving_track.length != 0"
                  >
                    map
                  </div>
                  <div class="col-md-6">
                    <h4
                      v-show="driving_track.length != 0"
                      class="col-md-8"
                      style="padding: 5px 0"
                    >
                      總筆數
                      <span style="color: red">
                        {{ driving_track_pagination.totalEntries }}
                      </span>
                      筆，每頁幾筆
                      <select
                        v-model="selectRecord"
                        @change="getDriverLocations"
                      >
                        <option :value="25" selected>25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                      </select>
                    </h4>
                    <div
                      class="col-md-4 text-right"
                      style="padding: 5px 0; margin: 10px 0"
                      v-show="driving_track.length != 0"
                    >
                      <button
                        class="btn btn-primary"
                        style="margin: 0px"
                        @click="downloadExcel"
                      >
                        下載 Excel 檔案
                      </button>
                    </div>
                    <table
                      class="table table-hover table-item"
                      v-show="driving_track.length != 0"
                    >
                      <thead>
                        <tr>
                          <th>排序號</th>
                          <th>日期時間</th>
                          <th>呼號/姓名</th>
                          <th>狀態</th>
                          <th>座標</th>
                          <th>
                            地址
                            <br />
                            (點擊記錄則會呈現地址)
                          </th>
                          <th>速度</th>
                          <th>方向角</th>
                          <th>
                            發動狀態
                            <br />
                            (A:發動中 V:未發動)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in driving_track"
                          :key="index"
                          @click="
                            getAddress(item.latitude, item.longitude, index)
                          "
                        >
                          <td>{{ item.sortNumber }}</td>
                          <td>{{ item.time }}</td>
                          <td>
                            {{ item.callNumber }} / {{ driver_index.name }}
                          </td>
                          <td>{{ checkStatus(item.status) }}</td>
                          <td>{{ item.latitude }} / {{ item.longitude }}</td>
                          <td v-if="item.address != 0">{{ item.address }}</td>
                          <td>{{ item.speed }}</td>
                          <td>{{ item.degrees }}</td>
                          <td>{{ item.driveStatus }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <el-pagination
                      v-show="driving_track.length != 0"
                      background
                      layout="prev, pager, next"
                      @current-change="clickPage"
                      :page-size="driving_track_pagination.perPage"
                      :page-count="driving_track_pagination.totalPages"
                      :current-page.sync="driving_track_pagination.currentPage"
                      style="padding: 25px 0 0 0; text-align: right"
                    ></el-pagination>
                  </div>
                </div>
              </div>
              <h3
                v-show="driving_track.length == 0 && !isSearch"
                class="col-md-12 text-center"
                style="padding: 60px 0"
              >
                請先選擇「司機資料」並搜尋
              </h3>
              <h3
                v-if="driving_track.length == 0 && isSearch"
                class="col-md-12 text-center"
                style="padding: 60px 0"
              >
                此日期區間無資料
              </h3>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
let searchMarker = null
let line = null

import API from '../../assets/js/libs/API'
import DownloadAPI from '../../assets/js/libs/DownloadAPI'
import { cookies, logoutCookies } from '@/utils/cookies'
import moment from 'moment'
import Driver from '../../assets/js/libs/Driver'
import 'vue-loading-overlay/dist/vue-loading.css'
import GoogleMapsLoader from 'google-maps'
import { ApiKey } from '../../assets/js/libs/GoogleAPI'
import DateSelect from '../../components/tool/DateSelect'
import Map from '../mapComponent/Map'
import CustomerSearch from '../../components/tool/CustomerAutoComplete'
import TrajectoryList from './TrajectoryList'
const crossMarker = require('../../assets/images/crosshair.png')
import checkStateAndDirection from '../../assets/js/tool/checkCarDirection'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'

export default {
  name: 'DriverTrajectory',
  components: {
    DateSelect,
    Map,
    CustomerSearch,
    TrajectoryList,
  },
  data() {
    return {
      fullPage: false,
      loader: null,
      min_datetime: moment().subtract(6, 'month').format(),
      driver_options: [],
      driver_index: -1,
      driving_track: [],
      driving_track_pagination: [],
      current_page: 1,
      selectRecord: 25,
      isSearch: false,
      map: null,
      geocoder: null,
      markers: [],
      simplePolyline: [],
      addressMarekr: null,
      points: [],
      directionsService: null,
      directionsRenderer: null,
      driverInfo: {
        name: '',
      },
      searchData: {
        value: '',
      },
      options: [
        { country: '台南市', value: '67000' },
        { country: '台南市', value: '67000' },
        { country: '高雄市', value: '64000' },
        { country: '臺北市', value: '63000' },
        { country: '台北市', value: '63000' },
        { country: '臺中市', value: '66000' },
        { country: '台中市', value: '66000' },
        { country: '桃園市', value: '68000' },
        { country: '新北市', value: '65000' },
        { country: '臺東縣', value: '10014' },
        { country: '台東縣', value: '10014' },
        { country: '彰化縣', value: '10007' },
        { country: '嘉義縣', value: '10010' },
        { country: '嘉義市', value: '10020' },
        { country: '新竹縣', value: '10004' },
        { country: '新竹市', value: '10018' },
        { country: '雲林縣', value: '10009' },
        { country: '基隆市', value: '10017' },
        { country: '苗栗縣', value: '10005' },
        { country: '屏東縣', value: '10013' },
        { country: '南投縣', value: '10008' },
        { country: '花蓮縣', value: '64000' },
        { country: '宜蘭縣', value: '10002' },
        { country: '澎湖縣', value: '10016' },
        { country: '金門縣', value: '09020' },
      ],
      addressDetail: [],
      addresses: [],
      autocomplete: {
        latitude: null,
        longitude: null,
      },
      focusDriver: null,
    }
  },
  computed: {
    driverGender() {
      if (this.driverInfo.gender === 0) return '男'
      return '女'
    },
  },
  methods: {
    _setFocusMarker(latlng) {
      if (this.focusDriver !== null) {
        this.focusDriver.setMap(null)
      }
      this.focusDriver = new google.maps.Marker({
        position: {
          lat: latlng.latitude,
          lng: latlng.longitude,
        },
        map: this.map,
        icon: crossMarker,
      })
      this.map.setCenter({
        lat: latlng.latitude,
        lng: latlng.longitude,
      })
      this.map.setZoom(16)
    },
    setLocationMarker() {
      if (!this.searchData.value) {
        alert('請輸入要搜尋的地址')
        return
      }
      if (searchMarker != null) {
        searchMarker.setMap(null)
        searchMarker = null
      }
      this.geocoder
        .geocode({ address: this.searchData.value })
        .then((res) => {
          const { results } = res
          this.map.setCenter(results[0].geometry.location)
          searchMarker = new google.maps.Marker({
            map: this.map,
            position: results[0].geometry.location,
            icon: crossMarker,
          })
        })
        .catch(() => {
          alert('查無資料，可以輸入更詳細資訊')
        })
    },
    setAutoSearchLocation(val) {
      this.autocomplete.latitude = val.latitude
      this.autocomplete.longitude = val.longitude
    },
    getAddresList(addr) {
      let address = addr.replace(/\(.*?\)/g, '')
      API.get(`searchSimilarAddress?address=${address}`)
        .then((res) => {
          this.addresses = []
          this.addressDetail = []
          if (res.result === 'err') return console.log('SimilarAddress-err')
          // 是否只剩區域剩一個
          if (res.result.cityDistrictRoad.length === 1) {
            let callBack = res.result.addressArray
            let addresses = []
            let addressDetail = []
            for (let address_i = 0; address_i < callBack.length; address_i++) {
              addresses.push(callBack[address_i].address)
              addressDetail.push({
                gps: callBack[address_i].gps.coordinates,
                address: callBack[address_i].address,
              })
            }
            this.addresses = addresses
            this.addressDetail = addressDetail
          } else {
            this.addresses = res.result.cityDistrictRoad
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    clearMainAddress() {
      this.addresses = []
      this.addressDetail = []
    },
    customerSelected(val) {
      if (val.address === null) {
        return
      }
      let value = {
        latitude: val.gps[1],
        longitude: val.gps[0],
        address: val.address,
      }
      this.setAutoSearchLocation(value)
      // console.log(value)
    },
    onChange(value) {
      if (value.includes('||') || value.includes('｜｜')) {
        let intersection = value
          .replace('市', '市 ')
          .replace(/\(.*?\)/g, '')
          .trim()
          .replace(/[ ]/g, '+')
          .replace('||', '+')
          .replace('｜｜', '+')
        let countryCode
        for (let city_i = 0; city_i < this.options.length; city_i++) {
          if (intersection.indexOf(this.options[city_i].country) !== -1) {
            countryCode = this.options[city_i].value
            break
          }
        }
        let roadlist = intersection.split('+')
        let road = roadlist[1] + '+' + roadlist[2]
        API.get(`intersectionInfo/?key=${road}&county_number=${countryCode}`)
          .then((res) => {
            if (res.result === 'err') return
            let arrayIntersection = res.result.intersectionInfo
            let addresses = []
            let addressDetail = []
            for (
              let intersection_i = 0;
              intersection_i < arrayIntersection.length;
              intersection_i++
            ) {
              addresses.push(
                '(' +
                  arrayIntersection[intersection_i].town +
                  ') ' +
                  arrayIntersection[intersection_i].city +
                  arrayIntersection[intersection_i].intersection +
                  '||' +
                  arrayIntersection[intersection_i].road,
              )
              addressDetail.push({
                gps: arrayIntersection[intersection_i].Gps.coordinates,
                address:
                  '(' +
                  arrayIntersection[intersection_i].intersection +
                  ') ' +
                  arrayIntersection[intersection_i].city +
                  arrayIntersection[intersection_i].intersection +
                  '||' +
                  arrayIntersection[intersection_i].road,
              })
            }
            this.addresses = addresses
            this.addressDetail = addressDetail
            return
          })
          .catch((err) => {
            console.log('intersectionInfo', err)
          })
        return
      }

      let address = value.trim().replace(/[ ]/g, '+')
      // console.log('====>address',address)
      if (address.indexOf('+') === -1) {
        this.getAddresList(value)
        return
      }
      let intersection = address.replace('市', '市 ').replace(/[ ]/g, '+')
      let countryCode
      for (let city_i = 0; city_i < this.options.length; city_i++) {
        if (intersection.indexOf(this.options[city_i].country) !== -1) {
          countryCode = this.options[city_i].value
          break
        }
      }
      // 交叉路口
      let roadlist = intersection.split('+')
      let road = roadlist[1] + '+' + roadlist[2]
      API.get(`intersectionInfo/?key=${road}&county_number=${countryCode}`)
        .then((res) => {
          // console.log(res)
          if (res.result === 'err') return
          let arrayIntersection = res.result.intersectionInfo
          let addresses = []
          let addressDetail = []
          for (
            let intersection_i = 0;
            intersection_i < arrayIntersection.length;
            intersection_i++
          ) {
            addresses.push(
              '(' +
                arrayIntersection[intersection_i].town +
                ') ' +
                arrayIntersection[intersection_i].intersection +
                '||' +
                arrayIntersection[intersection_i].road,
            )
            addressDetail.push({
              gps: arrayIntersection[intersection_i].Gps.coordinates,
              address:
                '(' +
                arrayIntersection[intersection_i].intersection +
                ') ' +
                arrayIntersection[intersection_i].intersection +
                '||' +
                arrayIntersection[intersection_i].road,
            })
          }
          this.addresses = addresses
          this.addressDetail = addressDetail
        })
        .catch((err) => {
          // this.loader.hide()
          console.log('intersectionInfo', err)
        })
    },
    getDriverInfo() {
      API.get(`track/driver/${this.driver_index.id}`).then((res) => {
        this.driverInfo = res.result
      })
    },
    changeTime(time) {
      return moment(time).tz('Asia/Irkutsk').format('YYYY-MM-DD HH:mm:ss')
    },
    downloadExcel() {
      alert('即將另開視窗，請到大量作業下載檔案')
      const startTime = new Date(this.$refs.startTime.getDate())
      const endTime = new Date(this.$refs.endTime.getDate())
      startTime.setUTCHours(startTime.getUTCHours() - 8)
      endTime.setUTCHours(endTime.getUTCHours() - 8)
      let newstartTime = moment(startTime).format('YYYY-MM-DD HH:mm:ss')
      let newendTime = moment(endTime).format('YYYY-MM-DD HH:mm:ss')
      const params = {
        start_date: newstartTime,
        end_date: newendTime,
      }
      DownloadAPI.post(
        `excel/driver_track-excel/${this.driver_index.id}?start_date=${newstartTime}&end_date=${newendTime}`,
        {
          headers: { 'x-access-token': cookies.get('user') },
          responseType: 'blob',
          params: params,
        },
      )
        .then(() => {
          let routeUrl = this.$router.resolve({
            path: '/serviceMain/WorkingStatus',
          })
          window.open(routeUrl.href, '_blank')
        })
        .catch(() => {
          alert('下載失敗')
        })
    },
    showLoading() {
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
    initMap() {
      let lat = parseFloat(cookies.get('GladAddressGps').coordinates[1])
      let lng = parseFloat(cookies.get('GladAddressGps').coordinates[0])
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: new google.maps.LatLng(lat, lng),
        gestureHandling: 'greedy',
        streetViewControl: false,
        zoom: 14,
        mapTypeId: 'roadmap',
      })
      this.geocoder = new google.maps.Geocoder()

      //   this.directionsService = new google.maps.DirectionsService();
      //   this.directionsService.route({
      //   origin:'台南高鐵站',
      //   destination:'台中高鐵站',
      //   travelMode: google.maps.TravelMode.DRIVING,
      // }).then((res) => {
      //   this.directionsRenderer = new google.maps.DirectionsRenderer({
      //     map: this.map,
      //     directions: res,
      //     polylineOptions: {
      //       strokeColor: 'yellow'
      //     },
      //     suppressMarkers: true
      //   });
      //   console.log('成功', res)
      // })
      // .catch((e) => window.alert("Directions request failed due to " + status));
    },
    getDriverLocations() {
      this.showLoading()
      this.driving_track_pagination.currentPage = 1
      const startTime = new Date(this.$refs.startTime.getDate())
      const endTime = new Date(this.$refs.endTime.getDate())
      startTime.setUTCHours(startTime.getUTCHours() - 8)
      endTime.setUTCHours(endTime.getUTCHours() - 8)
      let newstartTime = moment(startTime).format('YYYY-MM-DD HH:mm:ss')
      let newendTime = moment(endTime).format('YYYY-MM-DD HH:mm:ss')
      API.get(
        `track/${this.driver_index.id}?start_date=${newstartTime}&end_date=${newendTime}&current_page=${this.current_page}&per_page=${this.selectRecord}`,
      )
        // API.get(`https://staging.ap.gladmobile.com/web/api/track/505?start_date=2023-03-29%2016:00:00&end_date=2023-03-30%2016:00:00&current_page=1&per_page=50`)
        .then((res) => {
          this.loader.hide()
          this.removeMarker()
          this.simplePolyline = []
          this.driving_track = res.result.data
          this.driving_track.forEach((res) => {
            const resTime = new Date(res.time)
            resTime.setUTCHours(resTime.getUTCHours())
            res.callNumber = this.driverInfo.callNumber
            res.time = moment(resTime).format('YYYY-MM-DD HH:mm:ss')
          })
          this.driving_track_pagination = res.result.paging
          this.setMarker(this.driving_track)
        })
        .catch(() => {
          this.loader.hide()
          this.driving_track = []
        })
    },
    setMarker(data) {
      data.sort((a, b) => {
        return new Date(a.time) - new Date(b.time)
      })
      data.forEach((res, index) => {
        let point = {
          lat: res.latitude,
          lng: res.longitude,
          status: res.status,
          time: res.time,
          speed: res.speed,
          count: res.sortNumber,
        }
        let polyline = {
          lat: res.latitude,
          lng: res.longitude,
        }
        this.points.push(point)
        // map 判斷圖標
        let numberMarkerImg = {
          url: checkStateAndDirection.checkCarDirectionOutputImage(
            res.degrees,
            res.status,
          ).img,
          labelOrigin: new google.maps.Point(10, 25),
        }
        // map 標記點
        let marker = new google.maps.Marker({
          position: {
            lat: res.latitude,
            lng: res.longitude,
          },
          label: String(point.count),
          map: this.map,
          icon: numberMarkerImg,
          labelAnchor: new google.maps.Point(25, 0),
        })
        this.markers.push(marker)
        // map 畫線
        // this.simplePolyline.push(polyline)
        // if(line != null) {
        //   line.setMap(null)
        // }
        // line = new google.maps.Polyline({
        //   path: this.simplePolyline,
        //   geodesic: true,
        //   strokeColor: '#FF0000', // 折線顏色
        //   strokeOpacity: 1, // 折線透明度
        //   strokeWeight: 2, // 折線粗度
        // });
        // line.setMap(this.map);
        // map 標記點視窗
        let countStr = `<p>第 ${point.count} 筆資料</p>
          <p>時間 ${point.time}</p>`
        marker.addListener('click', function () {
          var infowindow = new google.maps.InfoWindow({
            content: countStr,
          })
          infowindow.open(this.map, marker)
        })
      })
      if (data.length > 0) {
        this.map.setCenter({
          lat: data[0].latitude,
          lng: data[0].longitude,
        })
      }
    },
    clickPage(page) {
      this.removeMarker()
      this.markers = []
      this.simplePolyline = []
      this.showLoading()
      const startTime = new Date(this.$refs.startTime.getDate())
      const endTime = new Date(this.$refs.endTime.getDate())
      startTime.setUTCHours(startTime.getUTCHours() - 8)
      endTime.setUTCHours(endTime.getUTCHours() - 8)
      let newStartTime = moment(startTime).format('YYYY-MM-DD HH:mm:ss')
      let newEndTime = moment(endTime).format('YYYY-MM-DD HH:mm:ss')
      API.get(
        `track/${this.driver_index.id}?start_date=${newStartTime}&end_date=${newEndTime}&current_page=${page}&per_page=${this.selectRecord}`,
      )
        .then((res) => {
          this.loader.hide()
          this.driving_track = res.result.data
          this.driving_track.forEach((res) => {
            const resTime = new Date(res.time)
            resTime.setUTCHours(resTime.getUTCHours())
            res.callNumber = this.driverInfo.callNumber
            res.time = moment(resTime).format('YYYY-MM-DD HH:mm:ss')
          })
          this.driving_track_pagination = res.result.paging
          this.setMarker(this.driving_track)
        })
        .catch(() => {
          this.loader.hide()
          this.driving_track = []
        })
    },
    getlist() {
      API.get(`track/driver`).then((res) => {
        this.driver_options = res.result
      })
    },
    getAddress(latitude, longitude, index) {
      let latlng = {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      }
      this.geocoder
        .geocode({ location: latlng })
        .then((res) => {
          this.driving_track[index].address = res.results[0].formatted_address
          this.$forceUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    checkStatus(status) {
      if (status === 0) {
        return '休息'
      } else if (status === 1) {
        return '空車'
      } else if (status === 2) {
        return '派遣中'
      } else if (status === 3) {
        return '載客中'
      } else if (status === 4) {
        return '排班'
      } else if (status === 5) {
        return '登出'
      } else if (status === 6) {
        return '失聯'
      } else if (status === 7) {
        return '停權'
      }
    },
    removeMarker() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null)
      }
      this.markers = []
    },
    searchTransactionList() {
      this.selectRecord = 25
      this.points = []
      const start_time = this.$refs.startTime.getDate()
      const end_time = this.$refs.endTime.getDate()
      BehaviorRecorder.record(
        '點擊',
        '司機軌跡',
        `搜尋司機軌跡，司機呼號：${this.driver_index.callNumber}，${start_time}~${end_time}`,
      )
      if (moment(end_time).isAfter(start_time)) {
        let max_time = moment(start_time)
          .add(3, 'day')
          .add(1, 'minute')
          .format()
        if (moment(max_time).isAfter(end_time)) {
          this.start_time = start_time
          this.end_time = end_time
          this.getDriverLocations()
        } else {
          alert('最多三天內')
          return
        }
      } else {
        alert('結束時間不得小於起始時間')
        return
      }
      if (this.driver_index === -1) {
        alert('請選擇呼號')
        return
      }
      this.isSearch = true
      this.selectRecord = 25
    },
    getAlltrack() {
      alert('繪圖中，請稍後再操作頁面')
      this.removeMarker()
      const startTime = new Date(this.$refs.startTime.getDate())
      const endTime = new Date(this.$refs.endTime.getDate())
      startTime.setUTCHours(startTime.getUTCHours() - 8)
      endTime.setUTCHours(endTime.getUTCHours() - 8)
      let newStartTime = moment(startTime).format('YYYY-MM-DD HH:mm:ss')
      let newEndTime = moment(endTime).format('YYYY-MM-DD HH:mm:ss')
      API.get(
        `track/all/${this.driver_index.id}?start_date=${newStartTime}&end_date=${newEndTime}`,
      ).then((res) => {
        this.driving_track = res.result
        this.driving_track.forEach((res) => {
          const resTime = new Date(res.time)
          resTime.setUTCHours(resTime.getUTCHours())
          res.callNumber = this.driverInfo.callNumber
          res.time = moment(resTime).format('YYYY-MM-DD HH:mm:ss')
        })
        this.setMarker(this.driving_track)
      })
    },
  },
  mounted() {
    const MainTeamCode = cookies.get('GladTeamCode')
    GoogleMapsLoader.KEY = ApiKey()
    GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
    GoogleMapsLoader.load(() => {
      window.initMap = this.initMap()
    })
    this.getlist(MainTeamCode)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span {
  font-weight: normal;
}

.table-item {
  display: block;
  overflow: auto;
  white-space: nowrap;
  width: 900px;
  height: 960px;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/DriverTrajectory.vue